import { Box, type BoxProps } from "@chakra-ui/react";
import React from "react";
import { VideoModal } from "ui/video";

const videoShort = "https://cdn.sanity.io/files/pwmfmi47/production/7cfaadde70b395fe36b56a60ae4bdcfe589939f2.mp4";
const videoSrc = "https://cdn.sanity.io/files/pwmfmi47/production/c1bd5391335a8eea1d7416dafa063e65719a1add.mp4";
const videoCaptions = "/assets/platform/ai-decisioning/aid-demo-captions.vtt";
const videoThumbnail =
  "https://cdn.sanity.io/images/pwmfmi47/production/c23a651a093e16b2821ddda01e009d460ea67cc5-2980x1620.webp";

export function AidDemoVideo(props: BoxProps) {
  return (
    <Box
      border="1px"
      borderColor="new.gray.150"
      borderRadius={{ base: "small", md: "big" }}
      mt={{ base: "bigger", md: "biggest" }}
      maxW="5xl"
      mx="auto"
      overflow="hidden"
      {...props}
    >
      <VideoModal
        iconTheme="dark"
        shortSrc={videoShort}
        src={videoSrc}
        captions={videoCaptions}
        thumbnail={videoThumbnail}
        uploadDate="Feb 10, 2025"
        videoId="aid-demo"
        title="AI Decisioning Demo"
        description="Alec Haase gives a quick overview and walk through of AI Decisioning, an AI platform that delivers unique and optimized experiences for each customer — without manual work or rigid rule-based logic."
      />
    </Box>
  );
}
